import { BelegStepDataResponse } from '@/types/service-response'
import { ProjectBookingBelegVersandSpesen } from '@/model/project/ProjectBookingBelegVersandSpesen'
import { ProjectBookingBelegZuschlagRabatt } from '@/model/project/ProjectBookingBelegZuschlagRabatt'
import { ProjectBookingBelegKonditionenLoc } from '@/model/project/ProjectBookingBelegKonditionenLoc'

export class ProjectBookingBeleg {
  public constructor (
    readonly VersandSpesen: ProjectBookingBelegVersandSpesen,
    readonly ZuschlagRabatt: ProjectBookingBelegZuschlagRabatt,
    readonly Konditionen: ProjectBookingBelegKonditionenLoc,
    readonly Kopftext: string | null,
    readonly Fusstext: string | null
  ) {}

  static createFromResponse (responseData: BelegStepDataResponse): ProjectBookingBeleg {
      return new ProjectBookingBeleg(
        ProjectBookingBelegVersandSpesen.createFromResponse(responseData.VersandSpesen),
        ProjectBookingBelegZuschlagRabatt.createFromResponse(responseData.ZuschlagRabatt),
        ProjectBookingBelegKonditionenLoc.createFromResponse(responseData.Konditionen),
        responseData.Kopftext,
        responseData.Fusstext
      )
  }
}
